import React from 'react'
import { SanityCategoryTableBlock } from '../../../../../types/generated/graphql-types'
import {
  sanityCategoryTableBlockToCategoryTableProps,
  sanityCategoryTableBlockToTextWithTableProps,
} from '../../../../mapping/CategoryTableMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { CategoryTable } from '../../../blocks/CategoryTable'
import { TextWithTable } from '../../../blocks/TextWithTable'
import { Section } from '../../../Section'

export type CategoryTableSerializerProps = SanityCategoryTableBlock & BlockWithId

export const CategoryTableSerializer = ({
  id,
  ...props
}: CategoryTableSerializerProps) => (
  <Section id={id}>
    {props.theme === 'secondary' ? (
      <TextWithTable {...sanityCategoryTableBlockToTextWithTableProps(props)} />
    ) : (
      <CategoryTable {...sanityCategoryTableBlockToCategoryTableProps(props)} />
    )}
  </Section>
)
